export class PreBillDaysConfiguration {
    _termNumber;
    jsTermNumber;
    _preBillDays;
    jsPreBillDays;
    _type = "custom";
    _active = true;
    jsActive = true;
    constructor(params) {
        this.termNumber = params.termNumber;
        this.preBillDays = params.preBillDays;
        if (params.type) {
            this.type = params.type;
        }
        if (params.active !== undefined)
            this.active = params.active;
        this.updateJsValues();
    }
    get active() {
        return this._active;
    }
    set active(v) {
        this._active = v;
        this.jsActive = v;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    updateJsValues() {
        this.jsTermNumber = this.termNumber;
        this.jsPreBillDays = this.preBillDays;
        this.jsActive = this.active;
    }
    updateModelValues() {
        this.termNumber = this.jsTermNumber;
        this.preBillDays = this.jsPreBillDays;
        this.active = this.jsActive;
    }
    get termNumber() {
        return this._termNumber;
    }
    set termNumber(value) {
        this._termNumber = value;
        this.jsTermNumber = value;
    }
    get preBillDays() {
        return this._preBillDays;
    }
    set preBillDays(value) {
        this._preBillDays = value;
    }
    get json() {
        return {
            termNumber: this.termNumber,
            preBillDays: this.preBillDays,
            type: this.type,
            active: this.active,
        };
    }
    toJSON() {
        return this.json;
    }
}
